import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatViews } from "@/utils/media";

interface HotRankingProps {
  movies: Movie[];
}

export default function HotRanking({ movies }: HotRankingProps) {
  const top = [...movies].sort((a, b) => b.views - a.views).slice(0, 8);
  const max = top[0]?.views || 1;

  return (
    <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
      {top.map((movie, i) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-3 md:gap-4 px-3 md:px-4 py-3 border-b border-background-200 last:border-b-0 hover:bg-background-200/60 transition-colors cursor-pointer"
        >
          <span
            className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center font-label text-base ${
              i < 3
                ? "bg-primary-500 text-background-50"
                : "bg-background-300 text-foreground-700"
            }`}
          >
            {i + 1}
          </span>
          <div className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
            <img
              src={movie.cover}
              alt={`${movie.title} 海报`}
              title={`${movie.title} ${movie.type}`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-heading font-bold text-sm text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
              {movie.title}
            </h3>
            <p className="text-[11px] text-foreground-500 mt-0.5 truncate">
              {movie.type} · {movie.region} · {movie.year}
            </p>
            <div className="mt-1.5 h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
              <div
                className="h-full rounded-full bg-accent-500"
                style={{ width: `${Math.max((movie.views / max) * 100, 6)}%` }}
              ></div>
            </div>
          </div>
          <div className="shrink-0 flex flex-col items-end gap-1">
            <span className="flex items-center gap-1 text-xs font-bold text-accent-500">
              <i className="ri-fire-line"></i>
              {formatViews(movie.views)}
            </span>
            <span className="text-[11px] text-foreground-500">{movie.score.toFixed(1)} 分</span>
          </div>
        </Link>
      ))}
    </div>
  );
}